import {
    PeopleAltOutlined,
    AutorenewOutlined,
    SyncLockOutlined,
    SettingsSuggestOutlined,
    FavoriteBorderOutlined,
    LoopOutlined,
    LegendToggleOutlined,
    EventAvailableOutlined,
    AccountBalanceOutlined,
    CurrencyExchangeOutlined,
    SwitchAccessShortcutAddOutlined,
    StarOutlined,
    AutoAwesomeOutlined,
    Diversity3Outlined
} from "@mui/icons-material";
import { COPY } from "app/constants";

export interface OnboardingBullet {
    Icon: React.ElementType;
    header: string;
    text: string;
}

export const LEND_BULLETS: OnboardingBullet[] = [
    {
        Icon: SettingsSuggestOutlined,
        header: "Open positions with custom risk profiles",
        text: `Choose ${COPY.ALLOWED_COLLATERAL_TERM}, ${COPY.STRATEGY_APY_TERM}, and max loan duration for prospective borrowers.`
    },
    {
        Icon: PeopleAltOutlined,
        header: "Match to peer-to-peer loans",
        text: "Earn interest from fixed-duration loans. Positions with low rates and flexible terms will match to more loans."
    },
    {
        Icon: AutorenewOutlined,
        header: "Auto-reinvest repayments",
        text: "Receive repayments back to your position. If a borrower defaults, the collateral is liquidated to repay the loan."
    },
    {
        Icon: SyncLockOutlined,
        header: "Withdraw early",
        text: "Collect partial interest by selling the loan back to the market before the due date."
    }
];

export const BORROW_BULLETS: OnboardingBullet[] = [
    {
        Icon: LoopOutlined,
        header: "Borrow peer-to-peer",
        text: "Supply collateral and maintain health for each separate borrow. No need to manage a global position."
    },
    {
        Icon: LegendToggleOutlined,
        header: "Enjoy fixed rates",
        text: "Pay the same APY for your entire loan. Repay only accrued interest when ending a loan early."
    },
    {
        Icon: FavoriteBorderOutlined,
        header: "Monitor loan health",
        text: "If your collateral value drops, avoid liquidation by topping up or partially repaying."
    },
    {
        Icon: EventAvailableOutlined,
        header: "Repay on time",
        text: "Repay by the due date or your loan will auto-extend. If a new offer isn't available, collateral will be liquidated."
    }
];

export const LEND_VAULT_BULLETS: OnboardingBullet[] = [
    {
        Icon: AccountBalanceOutlined,
        header: "Deposit in a Loopscale Vault",
        text: "Each vault has a unique risk profile and strategy curated by a third-party risk expert."
    },
    {
        Icon: LegendToggleOutlined,
        header: "Assets are supplied to Loopscale Markets",
        text: "Vaults allocate deposits to curator-approved markets. Major strategy updates take effect after a time delay."
    },
    {
        Icon: CurrencyExchangeOutlined,
        header: "Earn yield from borrowers",
        text: "Vaults generate returns from interest paid by borrowers borrowing from underlying markets."
    },
    {
        Icon: EventAvailableOutlined,
        header: "Withdraw your earnings at any time",
        text: "If the vault has low liquidity, choose between an instant withdrawal with a small fee or join a withdrawal queue."
    }
];

export const POINTS_BULLETS: OnboardingBullet[] = [
    {
        Icon: SwitchAccessShortcutAddOutlined,
        header: "Earn points by using Loopscale",
        text: "Loopscale Points track your activity in the protocol and are earned by lending, borrowing, looping, and referring users."
    },
    {
        Icon: StarOutlined,
        header: "Get point multipliers",
        text: "Some assets and Loops also earn external points from integrated protocols. Look for external logos next to the point stars."
    },
    {
        Icon: AutoAwesomeOutlined,
        header: "Earn points from external protocols",
        text: "Users are free to withdraw whenever they would like, but if the caps are hit then you may not be able to re-deposit."
    },
    {
        Icon: Diversity3Outlined,
        header: "Refer friends to earn more",
        text: "Earn 5% of all non-referral points your referrals generate with no cap on how many users you can invite."
    }
];
